howspace.widgets.onEvent('discussion:categories:preview-generation:failed', (widget, notification) => {
    howspace.aiGen.clearPromptTimeout(widget);
    const modal = $('dialog[data-source-widget-type="' + notification.object.widget.type + '"][data-source-widget-id="' + notification.object.widget.id + '"]');

    modal.find('.howspace-loader').remove();
    modal.find('.categories').removeClass('d-none');
    real.button.reset(modal.find('.btn-success'));

    howspace.components.modal.close(modal);
    real.notification.show(notification.object.error, 'danger', true);
});
